// // import React from 'react'
// // import { RouteObject } from 'react-router-dom'; // Import RouteObject type from react-router-dom
// // import LoginPage from '../components/Login'; // Import LoginPage component

// // const LoginRoutes: RouteObject = {
// //   path: 'login', // The path for the login route
// //   element: <LoginPage />, // The component that will be rendered when navigating to /login
// // };

// // export default LoginRoutes;


// import React, { lazy } from 'react';
// import { RouteObject,Outlet } from 'react-router-dom';
// import GuestGuard from "../utlils/guest-guards";
// import Loadable from "../ui-components/Loadable";

// // Lazy-loaded components using the Loadable HOC for Suspense
// const AuthLogin = Loadable(
//   lazy(() => import('../components/Login'))
// );


// // ==============================|| AUTH ROUTING ||============================== //

// const LoginRoutes: RouteObject = {
//   path: '/',
//   element: <GuestGuard><Outlet /></GuestGuard>, // Wrap routes with GuestGuard,
//   children: [
//     {
//       path: 'login', // Relative path for "login"
//       element: <AuthLogin />,
//     }
//   ],
// };

// export default LoginRoutes;

import React from 'react';
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import GuestGuard from '../guards/GuestGuard';
import Loadable from '../ui-components/Loadable';

// Lazy load the  login page
const LoginPage = Loadable(lazy(() => import('../views/pages/auth/loginPage')));

const LoginRoutes: RouteObject = {
  path: '/login',
  element: (
    <GuestGuard>
      <LoginPage />
    </GuestGuard>
  ),
};

export default LoginRoutes;
